import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'POLITICA_PRECO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setFiltro(filtro) {
    return {
        type: 'POLITICA_PRECO_FILTRO',
        payload: filtro
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'POLITICA_PRECO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('politicaPrecoForm', registro)
    ];
}

export function getLista() {

	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/politicaPreco?data=${DateFormat.formatarDataTelaParaSql(getState().politicaPreco.filtro.data)}`)
		.then(resp => {
			dispatch({
		        type: 'POLITICA_PRECO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {

		dispatch(setAguardando(true));
		
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/politicaPreco`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(setAguardando(false));
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/politicaPreco`, {
				...registro,
				estrategia: FormatUtils.formatarValorBanco(registro.estrategia, 2),
				preco_manual: FormatUtils.formatarValorBanco(registro.preco_manual, 4),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(setAguardando(false));
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/politicaPreco?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaUnidade() {
	const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
	return {
		type: 'POLITICA_PRECO_UNIDADE_SELECT_LISTADO',
		payload: request
	};
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'POLITICA_PRECO_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaDistribuidora() {
    const request = axios.get(`${consts.API_URL}/distribuidora/listarSelect`);
    return {
        type: 'POLITICA_PRECO_DISTRIBUIDORA_SELECT_LISTADO',
        payload: request
    };
}